import * as types from "./actionsTypes";
import { agent } from "../utils/agent";
import { setToaster, showToaster } from "../utils/helpers";
import * as API from "../utils/apiPath";
import toggleNetworkRequestStatus from "./toggleNetworkRequestStatus"; 

export function leadItrDataSuccess(leadItrData) {
  return { type: types.LOAD_LEAD_ITR_DATA_SUCCESS, leadItrData };
}
export function leadItrByLeadDataSuccess(leadItrByLeadData) {
  return { type: types.LOAD_LEAD_ITR_BY_LEAD_DATA_SUCCESS, leadItrByLeadData };
}

const addEditLeadItr = (params) => {
    return async function (dispatch) {
      dispatch(toggleNetworkRequestStatus(true));
      try {
        const response = await agent.post(API.CREATE_LEAD_ITR, params);
        dispatch(toggleNetworkRequestStatus(false));
        return response;
      } catch (error) {
        dispatch(toggleNetworkRequestStatus(false));
        throw error;
      } 
    };
}

const leadItrData = (params, preloader = true, returnVal = false) => {
    return async function (dispatch) {
      if (preloader) {
        dispatch(toggleNetworkRequestStatus(true));
      } 
      try {
        let response;
  
        if (returnVal) {
          response = await agent.post(API.GET_LEAD_ITR, params);
        } else {
          response = await agent.post(API.GET_LEAD_ITR, params);
        }
  
        if (preloader) {
          dispatch(toggleNetworkRequestStatus(false));
        }
  
        return response;
      } catch (error) {
        // Handle errors, e.g., log or dispatch an error action
        console.error("API Request Error:", error);
  
        if (preloader) {
          dispatch(toggleNetworkRequestStatus(false));
        } 
        throw error;
      }
    };
};

const leadItrByLeadData = (params, preloader = true, returnVal = false) => {
    return async function (dispatch) {
      if (preloader) {
        dispatch(toggleNetworkRequestStatus(true));
      } 
      try {
        let response;
  
        if (returnVal) {
          response = await agent.post(API.GET_LEAD_ITR_BY_LEAD, params);
        } else {
          response = await agent.post(API.GET_LEAD_ITR_BY_LEAD, params);
        }
  
        if (preloader) {
          dispatch(toggleNetworkRequestStatus(false));
        }
  
        return response;
      } catch (error) {
        // Handle errors, e.g., log or dispatch an error action
        console.error("API Request Error:", error);
  
        if (preloader) {
          dispatch(toggleNetworkRequestStatus(false));
        } 
        throw error;
      }
    };
};

export default {
    addEditLeadItr,
    leadItrData,
    leadItrDataSuccess,
    leadItrByLeadData,
    leadItrByLeadDataSuccess 
}